import { createBrowserRouter } from 'react-router-dom';
import { DashboardPage } from './pages/dashboard/DashboardPage';
import { JournalsPage } from './pages/journals/JournalsPage';
import { LedgerPage } from './pages/ledger/LedgerPage';
import { ReportsPage } from './pages/reports/ReportsPage';
import { DeclarationsPage } from './pages/declarations/DeclarationsPage';
import { SettingsPage } from './pages/settings/SettingsPage';
import DataSharingBenefitsPage from './pages/settings/DataSharingBenefitsPage';
import { FiscalYearsPage } from './pages/fiscal-years/FiscalYearsPage';
import { UsersPage } from './pages/users/UsersPage';
import { ActivityLogsPage } from './pages/users/ActivityLogsPage';
import { OrganizationPage } from './pages/organization/OrganizationPage';
import { ChatPage } from './pages/chat/ChatPage';
import { FixedAssetsPage } from './pages/fixed-assets/FixedAssetsPage';
import { AnalyticAccountingPage } from './pages/analytic-accounting/AnalyticAccountingPage';
import { RecurringEntriesPage } from './pages/recurring-entries/RecurringEntriesPage';
import { LoginPage } from './pages/auth/LoginPage';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { AuditorProtectedRoute } from './components/auth/AuditorProtectedRoute';
import { AuthCallbackPage } from './pages/auth/AuthCallbackPage';
import { NotFoundPage } from './pages/errors/NotFoundPage';
import { NoOrganizationPage } from './pages/errors/NoOrganizationPage';
import { AuditorClientsPage } from './pages/auditor/AuditorClientsPage';
import { AuditorCompanyRedirect } from './components/auditor/AuditorCompanyRedirect';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/callback',
    element: <AuthCallbackPage />
  },
  {
    // Route publique : compte authentifié mais sans organisation liée
    path: '/no-organization',
    element: <NoOrganizationPage />
  },
  {
    // Routes réservées aux auditeurs (role === 'audit')
    path: '/auditor',
    element: <AuditorProtectedRoute />,
    children: [
      {
        path: 'clients',
        element: <AuditorClientsPage />
      },
      {
        // Quand un auditeur ouvre une entreprise, il atterrit dans l'app compta
        // via les mêmes routes standard mais wrappées dans AuditorLayout
        path: 'company/:organizationId',
        element: <AuditorCompanyRedirect />
      },
      {
        // Raccourci : /auditor/* catch-all
        path: '*',
        element: <NotFoundPage />
      },
    ]
  },
  {
    path: '/',
    element: <ProtectedRoute />,
    children: [
      {
        path: '/',
        element: <DashboardPage />
      },
      {
        path: '/journals',
        element: <JournalsPage />
      },
      {
        path: '/ledger',
        element: <LedgerPage />
      },
      {
        path: '/reports',
        element: <ReportsPage />
      },
      {
        path: '/declarations',
        element: <DeclarationsPage />
      },
      {
        path: '/settings',
        element: <SettingsPage />
      },
      {
        path: '/settings/data-sharing-benefits',
        element: <DataSharingBenefitsPage />
      },
      {
        path: '/fiscal-years',
        element: <FiscalYearsPage />
      },
      {
        path: '/users',
        element: <UsersPage />
      },
      {
        path: '/activity-logs',
        element: <ActivityLogsPage />
      },
      {
        path: '/organization',
        element: <OrganizationPage />
      },
      {
        path: '/chat',
        element: <ChatPage />
      },
      {
        path: '/fixed-assets',
        element: <FixedAssetsPage />
      },
      {
        path: '/analytic-accounting',
        element: <AnalyticAccountingPage />
      },
      {
        path: '/recurring-entries',
        element: <RecurringEntriesPage />
      },
      {
        path: '*',
        element: <NotFoundPage />
      }
    ]
  }
], {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
});